import type { SVGProps } from "react";
export const YoutubeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className="fill-current"
    {...props}
  >
    <path
      d="M22.7809 7.45237C22.7809 7.45237 22.566 5.88392 21.9043 5.19522C21.0664 4.28881 20.1297 4.28437 19.7 4.23105C16.6234 4 12.0043 4 12.0043 4H11.9957C11.9957 4 7.37656 4 4.3 4.23105C3.87031 4.28437 2.93359 4.28881 2.0957 5.19522C1.43398 5.88392 1.22344 7.45237 1.22344 7.45237C1.22344 7.45237 1 9.29631 1 11.1358V12.8598C1 14.6992 1.21914 16.5432 1.21914 16.5432C1.21914 16.5432 1.43398 18.1116 2.09141 18.8003C2.9293 19.7067 4.0293 19.6756 4.51914 19.7734C6.28086 19.9467 12 20 12 20C12 20 16.6234 19.9911 19.7 19.7645C20.1297 19.7112 21.0664 19.7067 21.9043 18.8003C22.566 18.1116 22.7809 16.5432 22.7809 16.5432C22.7809 16.5432 23 14.7037 23 12.8598V11.1358C23 9.29631 22.7809 7.45237 22.7809 7.45237ZM9.72695 14.9525V8.55873L15.6695 11.7667L9.72695 14.9525Z"
      fill="currentColor"
    />
  </svg>
);
